import React from 'react'
import { ChevronRight } from 'lucide-react'
import type { HubProject } from '../../../api/data360'
import {
  PROJECT_HUB_META_CLASS,
  PROJECT_HUB_NAME_CLASS,
  PROJECT_HUB_ROW_HOVER,
  getHubProjectDisplayFields,
  handleRowKeyDown
} from './projectHubShared'

export default function ProjectHubListRowMobile({
  project,
  onOpen
}: {
  project: HubProject
  onOpen: (project: HubProject) => void
}) {
  const { client, application } = getHubProjectDisplayFields(project)

  const handleRowClick = () => {
    onOpen(project)
  }
  const handleRowKey = (e: React.KeyboardEvent<HTMLDivElement>) => {
    handleRowKeyDown(e, handleRowClick)
  }

  const categoriesTitle = application !== '—' ? application : undefined

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={`Open ${project.name}`}
      onClick={handleRowClick}
      onKeyDown={handleRowKey}
      className={`flex min-h-14 cursor-pointer items-center gap-3 px-4 py-2 ${PROJECT_HUB_ROW_HOVER} hover:-translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blueprint-blue/40`}
    >
      <div className="min-w-0 flex-1">
        <h3 className={PROJECT_HUB_NAME_CLASS}>
          {project.name}
        </h3>
        <p
          className={`mt-0.5 ${PROJECT_HUB_META_CLASS}`}
          title={categoriesTitle}
        >
          {[client !== '—' ? client : null, application].filter(Boolean).join(' · ')}
        </p>
      </div>
      <ChevronRight className="h-4 w-4 shrink-0 text-heritage-grey" />
    </div>
  )
}
